module.exports = __webpack_public_path__ + "8a402443d37ca63b95c9f2c70f1a5716.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cape-black.png
// module id = 1864
// module chunks = 0